import React, { useContext } from 'react'
import LanguageContext from '../helper/LanguageContext';
import { DE } from '../Languages/DE';
import { EN } from '../Languages/EN';
import './InviteExternalComponent.css';

export default function InviteExternalComponentPOL({ onClick, color, id }) {
    const { isGerm, strings } = useContext(LanguageContext);
    return (
        <div 
            onClick={() => onClick()} 
            className="invite-external-component"
        >
            <div 
                className={`invite-external-component__card${color ? ' invite-external-component__card--white' : ''}`}
                onMouseEnter={(e) => {
                    e.currentTarget.style.transform = 'translateY(-2px)';
                }}
                onMouseLeave={(e) => {
                    e.currentTarget.style.transform = 'translateY(0)';
                }}
            >
                <div 
                    className="invite-external-component__title"
                >
                    {strings.ll_nkk}
                </div>
                <div 
                    className="invite-external-component__actions"
                >
                    <div
                        className="invite-icon-button invite-external-component__action"
                        onMouseEnter={(e) => {
                            e.currentTarget.style.backgroundColor = 'rgba(255, 255, 255, 1)';
                            e.currentTarget.style.transform = 'scale(1.1)';
                        }}
                        onMouseLeave={(e) => {
                            e.currentTarget.style.backgroundColor = 'rgba(255, 255, 255, 0.8)';
                            e.currentTarget.style.transform = 'scale(1)';
                        }}
                    >
                        <span className="material-symbols-outlined invite-icon">chat</span>
                    </div>
                    <div
                        className="invite-icon-button invite-external-component__action"
                        onMouseEnter={(e) => {
                            e.currentTarget.style.backgroundColor = 'rgba(255, 255, 255, 1)';
                            e.currentTarget.style.transform = 'scale(1.1)';
                        }}
                        onMouseLeave={(e) => {
                            e.currentTarget.style.backgroundColor = 'rgba(255, 255, 255, 0.8)';
                            e.currentTarget.style.transform = 'scale(1)';
                        }}
                    >
                        <span className="material-symbols-outlined invite-icon">groups</span>
                    </div>
                    <div
                        className="invite-icon-button invite-external-component__action"
                        onMouseEnter={(e) => {
                            e.currentTarget.style.backgroundColor = 'rgba(255, 255, 255, 1)';
                            e.currentTarget.style.transform = 'scale(1.1)';
                        }}
                        onMouseLeave={(e) => {
                            e.currentTarget.style.backgroundColor = 'rgba(255, 255, 255, 0.8)';
                            e.currentTarget.style.transform = 'scale(1)';
                        }}
                    >
                        <span className="material-symbols-outlined invite-icon">mail</span>
                    </div>
                    <div
                        className="invite-icon-button invite-external-component__action"
                        onMouseEnter={(e) => {
                            e.currentTarget.style.backgroundColor = 'rgba(255, 255, 255, 1)';
                            e.currentTarget.style.transform = 'scale(1.1)';
                        }}
                        onMouseLeave={(e) => {
                            e.currentTarget.style.backgroundColor = 'rgba(255, 255, 255, 0.8)';
                            e.currentTarget.style.transform = 'scale(1)';
                        }}
                    >
                        <span className="material-symbols-outlined invite-icon">more_horiz</span>
                    </div>
                </div>
            </div>
        </div>
    )
}
